import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import axiosInstance from "../../shared/service/axios";
import { StatisticsResponse } from "./Statistics.constants";

export const useStatisticListMutation = (): UseMutationResult<
  StatisticsResponse,
  AxiosError,
  any
> =>
  useMutation<StatisticsResponse, AxiosError, any>(async (requestValues) => {
    const { data, status } = await axiosInstance.get(
      "reports/",
      requestValues.isForm
        ? {
            params: {
              start_date: requestValues.startDay,
              end_date: requestValues.endDay,
            },
          }
        : {}
    );

    return data;
  });
